module.exports = __webpack_public_path__ + "img/zk-icon-customer-details.ffcf683f.svg";